export default "__VITE_ASSET__e0ekLDKK__"